<template>
  <div id="app">
    <keep-alive :max="1">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
}
.renameDialog {
  .el-dialog {
    width: 460px !important;
    margin-top: 40vh;
  }
  .el-form-item__content {
    display: inline-block;
  }
  .el-dialog__header{
     text-align: left;
  }
  .el-dialog__body {
    padding: 20px;
    text-align: left;
  }
  .dialog-footer{
    .el-button{
      width: 120px;
    }
  }
  .el-input{
    width: 260px;
  }
  .el-form-item{
    margin-bottom: 0;
  }
}
</style>
